"use client"

import { memo } from "react"

import MusicControlBox from "@/features/footer/controls/musicControlBox"
import MusicPlayer from "./components/MusicPlayer"
import ArtistCard from "./components/ArtistCard"
import ConcertsCard from "./components/ConcertsCard"
import QueueCard from "@/components/aContinuacion/QueueCard"
import RecentActivity from "@/components/recientes/RecentActivity"
import DrawerHeader from "@/features/player/components/DrawerHeader"

type Props = {
  headerTrackName: string
  headerArtist: string
  isPlaying: boolean
  onClose?: () => void
  onMore: () => void
  onHeaderClick: () => void
  currentSong: any
  currentPlaylist: any
  songsAcontinuacion: any[]
  externalArtist: any
}

function PlayerContent({
  headerTrackName,
  headerArtist,
  isPlaying,
  onClose,
  onMore,
  onHeaderClick,
  currentSong,
  currentPlaylist,
  songsAcontinuacion,
  externalArtist,
}: Props) {
  return (
    <div className="w-full pb-10">
      {/* HEADER */}
      <DrawerHeader
        title={headerTrackName}
        subtitle={headerArtist}
        leftLabel={isPlaying ? "Sonando" : "Pausa"}
        onClose={onClose}
        onMore={onMore}
        onHeaderClick={onHeaderClick}
      />

      {/* PLAYER */}
      <section className="flex flex-col items-center">
        <MusicPlayer variant="sidebar" />

        <div className="flex w-full justify-center">
          <MusicControlBox />
        </div>
      </section>

      {/* ARTIST */}
      <section className="mt-4 px-4">
        <ArtistCard
          artistName={
            externalArtist?.artistName ??
            currentSong?.songArtist
          }
          artistImage={externalArtist?.image}
          fallbackImage={currentSong?.songimg}
          artistBio={
            externalArtist?.description ??
            `Artista de ${currentSong?.songName}`
          }
          artistLink={
            currentSong?.artistLink ??
            currentPlaylist?.artistLink
          }
        />
      </section>

      {/* CONCERTS */}
      <section className="mt-4 px-4">
        <ConcertsCard />
      </section>

      {/* QUEUE */}
      <section className="mt-4 px-4">
        <QueueCard songs={songsAcontinuacion} />
      </section>

      {/* RECENT */}
      <section className="mt-0">
        <RecentActivity limit={10} />
      </section>
    </div>
  )
}

export default memo(PlayerContent)